var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n            fill: #f1f1f1;\n            }\n\n            .b {\n            fill: #888;\n            fill-rule: evenodd;\n            }\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 15,
    cy: 15,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.019,3a.559.559,0,0,0-.287.079L2.283,5.049A.562.562,0,0,0,2,5.537v7.9a.562.562,0,0,0,.841.488l3.2-1.826,3.672,1.836A.559.559,0,0,0,9.946,14H9.99a.559.559,0,0,0,.266-.078L13.7,11.951a.562.562,0,0,0,.283-.488v-7.9a.562.562,0,0,0-.841-.488L9.951,4.9,6.28,3.064A.559.559,0,0,0,6.023,3Zm4.512,9.47,2.333-1.333V4.53L10.531,5.863ZM9.407,5.884,6.58,4.471v6.644l2.827,1.413ZM3.124,5.863,5.457,4.53v6.607L3.124,12.47Z",
    transform: "translate(7 7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.37a94863d059a527feb7f5daba8f9949.svg";
export { ForwardRef as ReactComponent };